import styles from './widget.module.scss';
import React from 'react';
import {classNames} from '../../support/classnames.ts';
import {Link} from 'react-router-dom';

interface OwnProps {
    children: React.ReactNode;
    isInteractive?: boolean;
    to?: string;
    onClick?: () => void;
}

export function Widget({children, isInteractive, to, onClick}: OwnProps) {
    if (to != null) {
        return (
            <Link
                to={to}
                className={classNames(styles.widget, {
                    [styles.has_hover]: isInteractive,
                })}
            >
                {children}
            </Link>
        );
    }
    return (
        <div
            className={classNames(styles.widget, {
                [styles.has_hover]: isInteractive,
            })}
            onClick={() => onClick && onClick()}
        >
            {children}
        </div>
    );
}
